'use es6';

import HubDbTable from '../models/HubDbTable';
import { RECEIVED_HUBDB_TABLE, REQUESTED_HUBDB_TABLE_FAILED, REQUESTED_HUBDB_TABLE } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new HubDbTable(), action) => {
  switch (action.type) {
    case REQUESTED_HUBDB_TABLE:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_HUBDB_TABLE:
      return action.payload.hubDbTable;
    case REQUESTED_HUBDB_TABLE_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});